<div class="grid grid--gap-4">
  <div
    class="grid__box grid__box--size-min cur-pointer {{ bellColor }}"
    *ngIf="notificationsCounts"
    [ngbPopover]="notificationsPopContent"
    autoClose="outside"
    placement="bottom-right"
    triggers="manual"
    popoverClass="w-450"
    #p2="ngbPopover"
    (click)="toggleWithNotificationsContext(p2)"
  >
    <app-icon [size]="'18'" [glyph]="'bell'"></app-icon>
  </div>
  <div class="grid__box grid__box--size-min {{ bellColor }}" *ngIf="!count">
    <app-icon [size]="'18'" [glyph]="'bell'"></app-icon>
  </div>
  <div class="grid__box grid__box--size-min">
    <span class="color-blue-dark">{{ count }}</span>
  </div>
</div>

<ng-template #notificationsPopContent>
  <div *ngFor="let inverval of notificationsList; let first = first" [ngClass]="{ 'mt-16': !first }">
    <div class="notification">
      <div class="mb-8">
        <span class="title title--s" *ngIf="currentDate === inverval.date">Сегодня</span>
        <span class="title title--s" *ngIf="currentDate !== inverval.date">{{ inverval.date | dateFormat: 'DD MMMM YYYY' }}</span>
      </div>
      <div class="notification__card pos-r" *ngFor="let notification of inverval.notifications; let last = last" [ngClass]="{ 'mb-8': !last }">
        <app-loader *ngIf="notificationChangeStatusLoading && notificationChangeStatusLoadingId === notification.id"></app-loader>
        <div class="grid">
          <div class="grid__box grid__box--size-8">
            <div
              class="label label--low"
              [ngClass]="{
                'label--low': notification.notification_type && notification.notification_type.priority === 1,
                'label--high': notification.notification_type && notification.notification_type.priority !== 1
              }"
            >
              {{ notification.notification_type && notification.notification_type.name }}
            </div>
          </div>
          <div class="grid__box grid__box--size-min grid__box--pull-right">
            <div class="grid grid--gap-4">
              <div class="grid__box grid__box--size-min">
                {{ notification.create_date | dateFormat: 'HH:mm' }}
              </div>
              <div class="grid__box grid__box--size-min cur-pointer" (click)="onChangeNotificationStatus(notification)" title="Пометить прочитанным">
                <app-icon [glyph]="'check'" [size]="'18'" [color]="'blue'" [class]="'icon--va-middle'"></app-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-8">
          <a
            class="link"
            *ngIf="notification.url_name !== null"
            target="_blank"
            [routerLink]="pagesMapService.makeRoutePath(notification.url_name, notification.positional_params, notification.query_params)"
          >
            {{ notification.text }}
          </a>
          <span *ngIf="notification.url_name === null">{{ notification.text }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="grid grid--gap-4 mt-16" *ngIf="isExistsHiddenNotifications">
    <div class="grid__box grid__box--size-min">
      <app-icon [glyph]="'check'" [size]="'16'" [color]="'blue'" [class]="'icon--va-middle'"></app-icon>
    </div>
    <div class="grid__box grid__box--size-min">
      <a class="link" (click)="onNavigate()" [routerLink]="['/', NOTIFICATIONS_PATHS.notifications]"
        >+{{ notificationsHiddenCounts }} {{ notificationsHiddenCounts | i18nPlural: itemPluralMapping['notification'] }}</a
      >
    </div>
  </div>
  <div class="mt-16" *ngIf="!isExistsHiddenNotifications">
    <a class="link link-gray" (click)="onNavigate()" [routerLink]="['/', NOTIFICATIONS_PATHS.notifications]">Перейти к уведомлениям</a>
  </div>
</ng-template>
